import { render, staticRenderFns } from "./Similars.vue?vue&type=template&id=5e6991ff&"
import script from "./Similars.vue?vue&type=script&lang=js&"
export * from "./Similars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports